import merge from "lodash.merge";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { ProposedProjectController } from "services/proposedProject/controller";
import { FormRenderer, useAccordionWizard } from "stories";
import { AccordionForm } from "stories/components/accordionForm";
import { useFileUpload } from "utils/customHooks/useFileUpload";
import { useToast } from "utils/customHooks/useToast";
import { removeEmptyValues } from "../../../loanDetails/elements/borrower/LoanDetailsBorrower";
import { getPermitDefaultValue, permitFormFields } from "./permitFormFields";

const proposedProjectController = ProposedProjectController();

export const PermitsKey = "get-permits";
const Permits = () => {
  const form = useForm({
    defaultValues: getPermitDefaultValue(),
  });

  const params = useParams();
  const queryKey = [PermitsKey, { id: params }];
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  const { next } = useAccordionWizard();

  const { isLoading: fetchLoading } = useQuery({
    queryKey,
    queryFn: () => proposedProjectController.getPermits(params.id),
    onSuccess: (data) => form.reset(merge(getPermitDefaultValue(), data)),
  });

  const handleUpdatePermits = async (values) => {
    return handleFileFields(values).then((values) => {
      values = removeEmptyValues(values);
      return proposedProjectController.updatePermits({
        ...values,
        opportunityId: params.id,
      });
    });
  };

  const { isLoading: postLoading, mutate } = useMutation(handleUpdatePermits, {
    onSuccess: () => {
      showToast("Permits updated!", "success");
      next();
      queryClient.invalidateQueries(queryKey);
    },
  });

  const { handleFileFields } = useFileUpload();

  return (
    <AccordionForm
      accordionTitle={"Permits"}
      accordionKey="permits"
      isPreLoading={fetchLoading}
      isPostLoading={postLoading}
      form={form}
      onSubmit={mutate}
    >
      <FormRenderer fields={permitFormFields} />
    </AccordionForm>
  );
};

export default Permits;
